(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3538,5664],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fblog%2F%5Bdigest%5D.tsx&page=%2Fblog%2F%5Bdigest%5D!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[digest]",
      function () {
        return __webpack_require__("./src/pages/blog/[digest].tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Blog/BlogPost.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ BlogPost; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");
/* harmony import */ var _components_Elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/components/Elements/index.ts");
/* harmony import */ var _hooks_useENSData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/hooks/useENSData.ts");
/* harmony import */ var _data_Constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/data/Constants.ts");
/* harmony import */ var _Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");








const BlogPost = (props)=>{
    const { post , ...rest } = props;
    const [, displayName] = (0,_hooks_useENSData__WEBPACK_IMPORTED_MODULE_4__/* .useENSData */ .L)(post.contributor);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .LinkBox */ .fG, {
        display: "flex",
        flexDir: "column",
        rounded: "lg",
        shadow: "xl",
        bg: "white",
        _dark: {
            bg: "gray.700"
        },
        overflowX: "hidden",
        ...rest,
        children: [
            post.cover_image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
                h: "52",
                src: post.cover_image,
                loading: "lazy",
                alt: post.title,
                width: "full",
                imgH: _data_Constants__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_BOX_SIZE */ .xh,
                imgW: _data_Constants__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_BOX_SIZE */ .xh * _data_Constants__WEBPACK_IMPORTED_MODULE_7__/* .WIKI_IMAGE_ASPECT_RATIO */ .ag
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                h: "fit-content",
                p: "4",
                flexDir: "column",
                flex: "auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                        flex: "auto",
                        align: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            href: "/blog/".concat(post.digest),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                                fontSize: "lg",
                                fontWeight: "bold",
                                noOfLines: 3,
                                children: post.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                        mt: 3,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                                justifyContent: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements__WEBPACK_IMPORTED_MODULE_3__/* .Avatar */ .qE, {
                                        address: post.contributor,
                                        size: 20,
                                        alt: "unknown"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                                        color: "brand.500",
                                        fontWeight: "bold",
                                        fontSize: "sm",
                                        marginLeft: 2,
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                                fontSize: "sm",
                                color: "gray.400",
                                _dark: {
                                    color: "whiteAlpha.400"
                                },
                                children: new Date((post.timestamp || 0) * 1000).toDateString()
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ "./src/pages/blog/[digest].tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BlogPostPage": function() { return /* binding */ BlogPostPage; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _digest_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__("./node_modules/react-icons/md/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 114 modules
var react_markdown = __webpack_require__("./node_modules/react-markdown/lib/react-markdown.js");
;// CONCATENATED MODULE: ./src/components/Blog/BlogMdComponents.tsx



const BlockQuote = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)("blockquote", {
        children: children
    });
};
const p = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)("p", {
        style: {
            marginBottom: "16px"
        },
        children: children
    });
};
const h1 = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
        as: "h1",
        mt: 8,
        mb: 4,
        children: children
    });
};
const h2 = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
        as: "h2",
        mt: 8,
        mb: 4,
        children: children
    });
};
const h3 = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
        as: "h3",
        mt: 8,
        mb: 4,
        children: children
    });
};
const img = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        style: {
            margin: "auto"
        },
        ...props,
        alt: "Blog entry asset"
    });
const a = (param)=>{
    let { href , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: href,
        ...props,
        style: {
            color: "#fe5caa",
            textDecoration: "underline"
        },
        children: children
    });
};
const allowedLinkProtocols = [
    "http",
    "https",
    "mailto",
    "tel",
    "ethereum",
    "crowdfund"
];
const uriTransformer = (uri)=>{
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    const { length  } = allowedLinkProtocols;
    let index = -1;
    // eslint-disable-next-line no-plusplus
    while(++index < length){
        const protocol = allowedLinkProtocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    return "#";
};
const components = {
    h1,
    h2,
    h3,
    a,
    blockquote: BlockQuote,
    p,
    img
};

// EXTERNAL MODULE: ./src/components/Blog/BlogPost.tsx
var BlogPost = __webpack_require__("./src/components/Blog/BlogPost.tsx");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
// EXTERNAL MODULE: ./src/hooks/useENSData.ts
var useENSData = __webpack_require__("./src/hooks/useENSData.ts");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 6 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
;// CONCATENATED MODULE: ./src/pages/blog/[digest].tsx











const BlogContentOverride = /!\[ \]\((https?:\/\/.*\.(?:png|jpg|svg|gif|jpeg))\?height=\d*\\&width=\d*\)/;
var __N_SSG = true;
const BlogPostPage = (param)=>{
    let { blog , blogEntries  } = param;
    const router = (0,next_router.useRouter)();
    const [, displayName] = (0,useENSData/* useENSData */.L)(blog.contributor);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* chakra.div */.m$.div, {
            bgColor: "blogPageBg",
            my: -8,
            py: 4,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* chakra.div */.m$.div, {
                w: "min(90%, 1100px)",
                mx: "auto",
                my: {
                    base: "10",
                    lg: "16"
                },
                children: [
                    blog ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                                title: blog.title,
                                description: "".concat(blog.title, " - ").concat(blog.body.replace(BlogContentOverride, "").slice(0, 200).trim(), "..."),
                                openGraph: {
                                    title: blog.title,
                                    description: "".concat(blog.title, " - ").concat(blog.body.replace(BlogContentOverride, "").slice(0, 200).trim(), "..."),
                                    images: [
                                        {
                                            url: String(blog.cover_image)
                                        }
                                    ]
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                onClick: ()=>router.push("/blog"),
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardBackspace */.dWm, {
                                        style: {
                                            marginRight: "5px",
                                            fontSize: "20px"
                                        }
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        textColor: "#718096",
                                        fontSize: "md",
                                        children: "Go Back to Blog Page"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                                my: 4,
                                as: "h1",
                                fontSize: {
                                    base: "3xl",
                                    lg: "5xl"
                                },
                                letterSpacing: "wide",
                                children: blog.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                                target: "_blank",
                                href: "https://mirror.xyz/".concat(blog.contributor),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                                    mb: 4,
                                    justifyContent: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Avatar */.qE, {
                                            address: blog.contributor,
                                            size: 20,
                                            alt: "unknown"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            marginLeft: 5,
                                            children: displayName
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                color: "gray.600",
                                mb: 3,
                                _dark: {
                                    color: "gray.400"
                                },
                                children: new Date((blog.timestamp || 0) * 1000).toDateString()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                components: components,
                                transformLinkUri: uriTransformer,
                                children: blog.body
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
                        spacing: "15",
                        mt: "12",
                        sx: {
                            p: {
                                lineHeight: "26px"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
                                alignItems: "center",
                                spacing: {
                                    base: 2,
                                    md: 4,
                                    lg: 8
                                },
                                px: {
                                    base: 4,
                                    md: 14,
                                    lg: "24"
                                },
                                py: "8",
                                bg: "gray.100",
                                _dark: {
                                    bg: "gray.700"
                                },
                                rounded: "lg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        fontWeight: "bold",
                                        fontSize: {
                                            base: "sm",
                                            md: "md",
                                            lg: "3xl"
                                        },
                                        textAlign: "center",
                                        children: "Join thousands of others in receiving the most interesting wikis on IQ.Wiki every week"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        as: "a",
                                        fontSize: {
                                            base: "xs",
                                            md: "md",
                                            lg: "inherit"
                                        },
                                        px: {
                                            base: "8",
                                            lg: 10
                                        },
                                        href: "https://www.getdrip.com/forms/505929689/submissions/new",
                                        target: "_blank",
                                        w: "fit-content",
                                        maxW: "fit-content",
                                        children: "Sign me up"
                                    })
                                ]
                            }),
                            blogEntries.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
                                spacing: "8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        as: "span",
                                        fontSize: "4xl",
                                        fontWeight: "bold",
                                        noOfLines: 3,
                                        children: "You might like"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* SimpleGrid */.MI, {
                                        alignSelf: "center",
                                        w: "full",
                                        mt: {
                                            base: "15",
                                            md: "16"
                                        },
                                        columns: {
                                            base: 2,
                                            md: 3
                                        },
                                        spacingX: "5",
                                        spacingY: "14",
                                        children: blogEntries.filter((bp)=>{
                                            return bp.digest !== (blog === null || blog === void 0 ? void 0 : blog.digest);
                                        }).slice(0, 3).map((b, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPost/* BlogPost */.J, {
                                                maxW: "420px",
                                                post: b
                                            }, i))
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var _digest_ = (BlogPostPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5675,2192,7249,8764,5619,4095,1300,8283,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fblog%2F%5Bdigest%5D.tsx&page=%2Fblog%2F%5Bdigest%5D!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);